import { configureStore } from '@reduxjs/toolkit'
import reservationReducer from './reducers/reservationReducer'
import priceReducer from './reducers/priceReducer'
import sidebarReducer from './reducers/sidebarSlice'
import bookingReducer from './reducers/bookingsReducer'
import invoicingReducer from './reducers/invoicingReducer'
import paymentReducer from './reducers/paymentReducer'
import dashboardReducer from './reducers/dashboardReducer'
import propertyBasicInfoReducer from './reducers/propertySlice'

export const Store = configureStore({
  reducer: {
    reservationReducer: reservationReducer,
    priceReducer: priceReducer,
    sidebar: sidebarReducer,
    bookingsReducer: bookingReducer,
    invoicingReducer: invoicingReducer,
    paymentReducer: paymentReducer,
    dashboardReducer: dashboardReducer,
    propertyBasicInfoReducer: propertyBasicInfoReducer,
  },
})
